// Rúbricas oficiales del Portafolio Docente 2026 — Módulo 3 (Trabajo Colaborativo para el Desarrollo Profesional)
// Fuente: Rúbricas oficiales CPEIP / DocenteMás 2026 (EM, PC, EB)
// Tarea 5: Trabajo Colaborativo para el Desarrollo Profesional
//
// 🆕 CAMBIOS 2026:
// - Eliminados de las rúbricas oficiales: "Reflexión sobre necesidades profesionales",
//   "Seguimiento de la implementación del trabajo colaborativo",
//   "Reflexión sobre creencias pedagógicas".
// - El componente "Excelencia" desaparece como categoría diferenciada.
// - Módulo 3 queda con SOLO 4 indicadores oficiales vigentes, todos parte de la Tarea 5.
//
// Mapeo 2024 → 2026:
//   m3-16 (Relevancia de la necesidad)           → m3-16 (Relevancia del problema a partir del análisis de evidencia)
//   m3-17 (Reflexión necesidades profesionales)  → ELIMINADO
//   m3-18 (Reflexión conjunta a través diálogo)  → m3-18 (Diálogo pedagógico en torno a la implementación...)
//   m3-19 (Seguimiento de la implementación)     → ELIMINADO
//   m3-21 (Aprendizajes profesionales)           → m3-21 (Aprendizajes profesionales a partir de la experiencia de trabajo colaborativo)
//   m3-22 (Reflexión sobre creencias)            → ELIMINADO
//   m3-23 (Evaluación de la forma de trabajo)    → m3-23 (Evaluación conjunta de la forma de trabajar en la experiencia colaborativa)

// Datos de resultados nacionales (solo para los indicadores VIGENTES en 2026).
// Los porcentajes provienen del proceso 2024 — pendientes de actualización oficial 2026.
const RESULTADOS_M3 = {
    'indicador-m3-16': { dificultad: 'Baja',  destacado: 31.4, competente: 55.9, basico: 10.5, insatisfactorio: 2.2, totalDocentes: 15884, lecturaSistema: 'El 87,3% en Competente o Destacado. Fortaleza del sistema en identificar problemas relevantes a partir del análisis de evidencia.' },
    'indicador-m3-18': { dificultad: 'Alta',  destacado: 10.2, competente: 17.8, basico: 67.9, insatisfactorio: 4.1, totalDocentes: 15884, lecturaSistema: 'El 72% en Básico o Insuficiente. El diálogo pedagógico en torno a la implementación pocas veces logra transformarse en reflexión genuinamente conjunta.' },
    'indicador-m3-21': { dificultad: 'Baja',  destacado: 25.0, competente: 46.6, basico: 22.1, insatisfactorio: 6.3, totalDocentes: 15884, lecturaSistema: 'El 71,6% en Competente o Destacado. Los docentes identifican aprendizajes profesionales, pero pocas veces los ilustran con situaciones concretas.' },
    'indicador-m3-23': { dificultad: 'Media', destacado: 13.4, competente: 42.3, basico: 14.5, insatisfactorio: 29.8, totalDocentes: 15884, lecturaSistema: 'Estadística histórica 2024 — indicador reformulado en 2026. La evaluación crítica conjunta de la forma de trabajar requiere fortalecimiento.' },
};

// Mensaje estratégico común: priorización inteligente
export const ESTRATEGIA_MODULO_3 = {
    titulo: '¿Buscar todos los Destacados? No es la mejor estrategia.',
    cuerpo:
        'En el Portafolio Docente 2026, la mejor estrategia no es buscar todos los Destacados, sino maximizar tu resultado global de manera sostenible. ' +
        'En el Módulo 3 los 4 indicadores son ahora vigentes y se evalúan en conjunto: prioriza la coherencia entre el problema abordado, el diálogo pedagógico, el aprendizaje profesional y la evaluación conjunta del proceso.',
    pilares: [
        { titulo: 'Comprensión estructural', texto: 'En 2026 el Módulo 3 tiene 4 indicadores integrados, no hay componente de Excelencia.' },
        { titulo: 'Priorización inteligente', texto: 'Invierte tu energía donde un esfuerzo bien dirigido convierte un Básico en Competente.' },
        { titulo: 'Equilibrio sostenible', texto: 'Mejor un Portafolio Competente integral que un Destacado en algunas piezas y un Insuficiente en otras.' },
        { titulo: 'Desarrollo auténtico', texto: 'Refleja tu identidad docente real. La autenticidad pedagógica pesa más que el lenguaje técnico.' },
    ],
};

export const RUBRICAS_OFICIALES_M3 = [
    {
        id: 'rubrica-m3-16',
        tarea: 'tarea-7',
        tareaLabel: 'Tarea 5 · A.1',
        indicadorId: 'indicador-m3-16',
        indicadorNum: 16,
        tipo: 'Vigente 2026',
        nombre: 'Relevancia del problema a partir del análisis de evidencia',
        descripcion:
            'Evalúa la capacidad de el/la docente para comprender la relevancia que tiene abordar problemas para el proceso de enseñanza y aprendizaje de los/las estudiantes y lo fundamenta en el análisis de evidencias.',
        evidencia: 'Tarea 5. A.1 — Relevancia del problema a partir del análisis de evidencia (puede ser compartida con el equipo).',
        niveles: {
            insatisfactorio: { label: 'Insatisfactorio', criterios: ['No cumple con la condición del nivel Básico, o bien, no adjunta evidencia.'] },
            basico: {
                label: 'Básico',
                criterios: [
                    'El/la docente presenta un problema o necesidad relacionado con el proceso de enseñanza y aprendizaje, que abordó en la experiencia de trabajo colaborativo, coherente con la evidencia presentada.',
                    'Y explica su relevancia para el aprendizaje de sus estudiantes SIN basarse en el análisis de la evidencia revisada.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'El/la docente presenta un problema o necesidad relacionado con el proceso de enseñanza y aprendizaje, coherente con la evidencia presentada.',
                    'Y fundamenta su relevancia para el aprendizaje de sus estudiantes BASÁNDOSE en el análisis de la evidencia revisada.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y, además:',
                    'Enriquece el análisis INTEGRANDO INFORMACIÓN DE DISTINTA NATURALEZA para comprender la relevancia del problema para el proceso de enseñanza y aprendizaje.',
                ],
            },
        },
        competenteVsDestacado: {
            competente: 'Fundamenta la relevancia A PARTIR del análisis de la evidencia.',
            destacado: 'Integra información de distinta naturaleza (cualitativa, cuantitativa, fuentes diversas) para enriquecer el análisis.',
        },
        notas: [
            'Es indispensable adjuntar la evidencia para evaluar este indicador.',
            'Para Destacado debes triangular distintas fuentes/naturalezas de evidencia, no solo profundizar en una.',
        ],
    },
    {
        id: 'rubrica-m3-18',
        tarea: 'tarea-8',
        tareaLabel: 'Tarea 5 · A.2',
        indicadorId: 'indicador-m3-18',
        indicadorNum: 18,
        tipo: 'Vigente 2026',
        nombre: 'Diálogo pedagógico en torno a la implementación del trabajo colaborativo',
        descripcion:
            'Evalúa la capacidad de el/la docente para reflexionar con otros/as integrantes de la comunidad educativa o redes a través del diálogo, estableciendo relaciones entre el aprendizaje de los/as estudiantes y la práctica de enseñanza, para tomar decisiones fundadas en un conocimiento construido en conjunto.',
        evidencia: 'Tarea 5. A.2 — puede ser compartida con el equipo.',
        niveles: {
            insatisfactorio: { label: 'Insatisfactorio', criterios: ['No cumple con la condición del nivel Básico.'] },
            basico: {
                label: 'Básico',
                criterios: [
                    'Presenta una propuesta elaborada en conjunto con otros, centrada en aspectos pedagógicos para abordar la problemática, PERO SIN dar cuenta de un proceso reflexivo.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Da cuenta de una REFLEXIÓN PEDAGÓGICA CONJUNTA para abordar la problemática, estableciendo una decisión sobre la mejor forma de abordarla.',
                    'Y en ese proceso reflexivo logra RELACIONAR el aprendizaje de los/as estudiantes con la práctica pedagógica.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y, además, INCORPORA alguno de estos aspectos que profundizan la reflexión:',
                    'Los fundamentos teóricos de la práctica pedagógica.',
                    'El rol y misión como docentes.',
                    'Las motivaciones profesionales.',
                ],
            },
        },
        competenteVsDestacado: {
            competente: 'Reflexión conjunta que relaciona aprendizaje del estudiante con práctica pedagógica.',
            destacado: 'La reflexión incorpora teoría, rol docente o motivaciones profesionales que la profundizan.',
        },
        notas: [
            'Reflexión conjunta = indagación con hipótesis, argumentos y contraargumentos (no solo intercambio de opiniones).',
            'Indicador con la mayor dificultad nacional: 72% en Básico o Insuficiente.',
        ],
    },
    {
        id: 'rubrica-m3-23',
        tarea: 'tarea-9',
        tareaLabel: 'Tarea 5 · B',
        indicadorId: 'indicador-m3-23',
        indicadorNum: 23,
        tipo: 'Vigente 2026',
        nombre: 'Evaluación conjunta de la forma de trabajar en la experiencia colaborativa',
        descripcion:
            'Evalúa la capacidad de el/la docente para evaluar de manera crítica la forma de trabajo desarrollada durante la experiencia, identificando aquellos aspectos que facilitaron y obstaculizaron la consecución de los objetivos del trabajo colaborativo para reconocer lo que es valioso de aplicar en futuras implementaciones.',
        evidencia: 'Tarea 5. B — Evaluación conjunta de la forma de trabajar (puede ser compartida con el equipo).',
        niveles: {
            insatisfactorio: { label: 'Insatisfactorio', criterios: ['No cumple con la condición del nivel Básico.'] },
            basico: {
                label: 'Básico',
                criterios: [
                    'Explica SOLO UN aspecto de las formas de trabajo implementadas en la experiencia colaborativa que facilitó, o bien, que obstaculizó la consecución de los objetivos planteados.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Explica POR QUÉ algunos aspectos de las formas de trabajo FACILITARON y otros OBSTACULIZARON la consecución de los objetivos planteados.',
                    'Y señala algo que aprendió sobre estas formas de trabajo que podría aplicar en otras experiencias de trabajo colaborativo.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y, además:',
                    'DESCRIBE LA FORMA en que IMPLEMENTARÍA el aprendizaje logrado en otras experiencias.',
                ],
            },
        },
        competenteVsDestacado: {
            competente: 'Analiza facilitadores y obstaculizadores, y extrae un aprendizaje aplicable.',
            destacado: 'Proyecta cómo implementaría ese aprendizaje en una nueva experiencia concreta.',
        },
        notas: [
            'Competente exige analizar AMBOS (facilitadores y obstaculizadores), no solo uno.',
            'Formas de trabajo = organización, roles, plazos, reuniones, observaciones cruzadas, etc.',
        ],
    },
    {
        id: 'rubrica-m3-21',
        tarea: 'tarea-9',
        tareaLabel: 'Tarea 5 · C',
        indicadorId: 'indicador-m3-21',
        indicadorNum: 21,
        tipo: 'Vigente 2026',
        nombre: 'Aprendizajes profesionales a partir de la experiencia de trabajo colaborativo',
        descripcion:
            'Evalúa la capacidad de el/la docente para evaluar el aprendizaje profesional que logró a partir del trabajo colaborativo considerando cómo se han modificado sus conocimientos o habilidades y cómo ello se ha manifestado en su práctica y en el aprendizaje de sus estudiantes.',
        evidencia: 'Tarea 5. C — respuesta INDIVIDUAL (no compartible con el equipo).',
        niveles: {
            insatisfactorio: { label: 'Insatisfactorio', criterios: ['No cumple alguna de las condiciones del nivel Básico.'] },
            basico: {
                label: 'Básico',
                criterios: [
                    'El/la docente RECONOCE el aporte de la experiencia identificando lo que aprendió.',
                    'Señala cómo dicho aprendizaje se manifiesta en su práctica pedagógica, sin ilustrar con situaciones concretas.',
                    'Y señala que su aprendizaje profesional ha repercutido en los/as estudiantes, sin explicar o ejemplificar.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'El/la docente EVALÚA el aporte identificando lo aprendido e ILUSTRANDO con SITUACIONES CONCRETAS cómo dicho aprendizaje se manifiesta en su práctica pedagógica.',
                    'Explica o ejemplifica la forma en que su aprendizaje ha repercutido en los/as estudiantes.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y, además, da cuenta de:',
                    'DIFICULTADES, CUESTIONAMIENTOS o APRENSIONES que le surgieron en el camino.',
                    'O EVALÚA CRÍTICAMENTE su aprendizaje explicando algún aspecto MENOS LOGRADO.',
                ],
            },
        },
        competenteVsDestacado: {
            competente: 'Aprendizajes ilustrados con situaciones concretas y su repercusión en los/as estudiantes.',
            destacado: 'Reconoce dificultades, cuestionamientos o lo menos logrado: humildad intelectual.',
        },
        notas: [
            'Respuesta INDIVIDUAL: cada docente debe elaborar la suya, no se comparte con el equipo.',
            'Destacado pide HUMILDAD INTELECTUAL: reconocer dudas, dificultades o lo que aún no logras.',
        ],
    },
].map((rubrica) => {
    const data = RESULTADOS_M3[rubrica.indicadorId];
    if (data) {
        rubrica.resultadosNacionales = data;
        rubrica.dificultad = data.dificultad;
    }
    return rubrica;
});

export const RUBRICAS_M3_POR_TAREA = {
    'tarea-7': RUBRICAS_OFICIALES_M3.filter((r) => r.tarea === 'tarea-7'),
    'tarea-8': RUBRICAS_OFICIALES_M3.filter((r) => r.tarea === 'tarea-8'),
    'tarea-9': RUBRICAS_OFICIALES_M3.filter((r) => r.tarea === 'tarea-9'),
};
